import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const EnterpriseVessel = AiseaApiFactory.get("enterpriseVessel");

export default {
  /**
   * 法人の船舶一覧を取得
   * @param request パラメータ
   */
  fetchVessels({ commit }, request) {
    return EnterpriseVessel.search(request).then(d => {
      commit("SET_VESSELS", d.data.vessels);
      commit("SET_PAGING", d.data.pageable);
    });
  },
  /**
   * 法人船舶を取得する
   *
   * @param id 船舶ID
   *
   * @return {object} 船舶情報
   * 注:船舶情報がない場合は404がthrowされる
   *
   */
  getVessel(_, id) {
    return EnterpriseVessel.fetchVessel(id);
  },

  /**
   * 法人船舶を取得
   * @param id 船舶ID
   * @deprecated getVesselとロジックが一緒なのでgetVesselを使用する。
   */
  // TODO getVesselとロジックが一緒なので消す
  fetchVessel(_, id) {
    return EnterpriseVessel.fetchVessel(id);
  },
}
